import React from 'react';
import { pathOr, prop } from 'ramda';
import styled from 'styled-components';

// FIXME: https://material.io/guidelines/style/typography.html

export const Em = styled.span`
  color: ${({ theme }) => theme.colors.grey500};
`;

export const Strong = styled.span`
  font-weight: 500;
  letter-spacing: 2%;
`;

export const PrimaryStrong = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.red};
`;

export const Header = styled.span`
  font-size: 18px;
`;

export const Title = Strong.extend`
  font-size: 18px;
  line-height: 21px;
`;

export const Note = Em.extend`
  font-size: 14px;
`;

export const SmallTitle = Strong.extend`
  font-size: 13px;
`;

export const SmallNote = Em.extend`
  font-size: 12px;
`;

export const Tiny = styled.span`
  font-size: 11px;
`;

export const TinyTitle = Strong.extend`
  font-size: 11px;
`;

export const TinyNote = Em.extend`
  font-size: 11px;
`;

const Tag = ({ is: Tag, ...props }) => <Tag {...props} />;

Tag.defaultProps = { is: 'span' };

export const Text = styled(
  ({
    fontSize,
    fontWeight,
    color,
    lineHeight,
    whiteSpace,
    truncate,
    ...props
  }) => <Tag {...props} />,
)`
  font-size: ${({ fontSize }) => fontSize || '14px'};

  font-weight: ${({ fontWeight }) => fontWeight || 400};

  text-decoration: ${({ textDecoration }) => textDecoration || 'none'};

  color: ${({ color, theme }) =>
    pathOr(null, ['colors', color], theme) || color};

  line-height: ${prop('lineHeight')};

  white-space: ${prop('whiteSpace')};

  ${({ truncate }) =>
    truncate
      ? `
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      `
      : null};
`;

Text.defaultProps = {
  fontSize: '13px',
  lineHeight: 1.54,
};

export const Headline = props => (
  <Text fontSize="24px" lineHeight="32px" {...props} />
);

export const Display2Light = props => (
  <Text fontSize="45px" fontWeight={300} lineHeight={1.07} {...props} />
);

export const SubheadingBold = props => (
  <Text fontSize="15px" fontWeight="700" lineHeight={1.87} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/Text.jsx